export default __webpack_public_path__ + "images/pencil.v-9e04f0c3a12b268c366e4cac0afbdd68.svg";